import React, { useEffect, useMemo, useRef, useState } from 'react';

import { animateNumber, dotFormatter, isMobile } from '../../../../../helpers';
import { JackpotTierName } from '../../../../../enums';
import { useStore } from '../../../../../hooks';
import { NSP } from '../../../../../constants';
import { observer } from 'mobx-react-lite';

interface JackpotTierProps {
  symbol: string;
  name: JackpotTierName;
  onClick: () => void;
}

export const JackpotTier: React.FC<JackpotTierProps> = observer(({
  name,
  symbol,
  onClick
}) => {

  const displayAmountRef = useRef<HTMLDivElement | null>(null);

  const { jackpotStore, gameStore } = useStore();
  const { jakpotMap } = jackpotStore;
  const { currencyCode } = gameStore;

  const precision = useMemo(() => {
    return (isMobile() && currencyCode === NSP) ? 0 : 2;
  }, [currencyCode]);
  
  const amount = jakpotMap[name]?.amount || 0;
  const [ displayAmount, setDisplayAmount ] = useState(amount);

  useEffect(() => {
    setDisplayAmount(amount);
    animateNumber(displayAmountRef.current, displayAmount, amount, 500, precision);
  }, [amount]);

  return (
    <div className="jackpot-main-header-bl" onClick={onClick}>
      <img
        alt={name}
        src={symbol}
        className="jackpot-main-header-bg-img"
      />
      <span className="jackpot-main-header-bg-txt" ref={displayAmountRef}>
        { dotFormatter(displayAmount, precision) }
      </span>
    </div>
  );
});
